module.exports = __webpack_public_path__ + "img/sxt.a2e8ac23.png";